import React from "react";
import LoadingComponent from "src/components/General/Loading";
import { PsModal } from "src/components/General/Modal";
import { AdminService } from "src/services/AdminService";
import { PcForm } from "./PcForm";

export interface ProfessionalConnectModalProps {
  pcSlug: string;
  cb: (pc: boolean) => void;
}

export interface ProfessionalConnectModalMethods {
  showModal(): void;
}

// eslint-disable-next-line react/display-name
export const ProfessionalConnectModal = React.forwardRef<
  ProfessionalConnectModalMethods,
  ProfessionalConnectModalProps
>((props, ref) => {
  const [visible, setVisible] = React.useState(false);
  const [error, setError] = React.useState("");
  const [loading, setLoading] = React.useState(true);
  const [profile, setProfile] = React.useState();
  React.useImperativeHandle(ref, () => ({
    showModal(): void {
      setVisible(true);
      setError(null);
      setLoading(true);
      AdminService.getNetworkProfile(props.pcSlug)
        .then((result) => {
          setProfile(result.profile);
          return setLoading(false);
        })
        .catch((error) => {
          setLoading(false);
          console.error(error);
          setError("Unable to get professional connect profile, please try again!");
        });
    },
  }));
  return (
    <>
      <PsModal visible={visible} toggleCb={(): void => setVisible(!visible)} title={"Professional Connect"}>
        {loading === true && <LoadingComponent />}
        {loading === false && !error && (
          <PcForm
            profile={profile}
            slug={props.pcSlug}
            cb={(isPc: boolean): void => {
              setVisible(false);
              props.cb(isPc);
            }}
          />
        )}
        {error && <div className="alert alert-danger">{error}</div>}
      </PsModal>
    </>
  );
});
